import { restApiActions } from 'redux/redux-actions';

export const sellersItemsActions = restApiActions('sellers', 'items');
export const sellersMarkAsReadActions = restApiActions('sellers', 'mark-as-read');
export const sellersAcceptActions = restApiActions('sellers', 'accept');

export default restApiActions('sellers');
